import { Injectable } from '@angular/core';
import { CustomHttpClientService } from 'src/app/infrastructure/services/custom-http-client.service';
import { IncidentDto } from '../models/IncidentDto';
import { PostDto } from '../models/PostDto';
import { lastValueFrom, map } from 'rxjs';
import { PostSearchFilters } from '../models/PostSearchFilters';
import {
  AchInformationBoardCollection,
  ACHInformationDto,
} from '../models/ACHInformationDto';
import { BehaviorSubject } from 'rxjs';
import { FilterDto } from 'src/app/models/FilterDto';
import { ViewBoardPostDto } from '../models/ViewBoardPostDto';

@Injectable({
  providedIn: 'root',
})
export class AchInformationBoardService {
  constructor(private http: CustomHttpClientService) {}

  public filtersSubject = new BehaviorSubject<PostSearchFilters | null>(null);
  public filterListSubject = new BehaviorSubject<FilterDto[]>([]);
  public inputSearch = new BehaviorSubject<string>('');

  async getAllIncidents(): Promise<IncidentDto[]> {
    return lastValueFrom(this.http.get<IncidentDto[]>(`api/ach-board/posts`));
  }

  async GetAllCategories() {
    return lastValueFrom(
      this.http.get(`api/ach-board/categories`).pipe(map((data: any) => data)),
    );
  }

  GetAllCategoriesWithPostCount(searchFilter: PostSearchFilters) {
    return this.http
      .post(`api/ach-board/categories-count`, searchFilter)
      .pipe(map((data: any) => data));
  }

  async GetEmailAndCellPhoneNumbersCount(communicationTypeName: string) {
    return lastValueFrom(
      this.http
        .get(
          `api/ach-board/posts/notifications?type=${encodeURIComponent(communicationTypeName)}`,
        )
        .pipe(map((data: any) => data)),
    );
  }

  CreatePost(data: PostDto) {
    return this.http
      .post(`api/ach-board/posts`, data)
      .pipe(map((data: any) => data));
  }

  UpdatePost(postId: number, data: PostDto) {
    return this.http
      .put(`api/ach-board/posts/${postId}`, data)
      .pipe(map((data: any) => data));
  }

  GetCommunicationTypes() {
    return this.http
      .get(`api/select-list/BoardPostCommunicationType`)
      .pipe(map((data: any) => data));
  }

  GetAllPosts(searchFilter: PostSearchFilters, skip: number, take: number) {
    return this.http
      .post<AchInformationBoardCollection>(
        `api/ach-board/posts/list?skip=${skip}&take=${take}`,
        searchFilter,
      )
      .pipe(map((data: AchInformationBoardCollection) => data));
  }

  GetBoardPostByIdAndUpdateViewCount(postId: number) {
    return this.http
      .put<ACHInformationDto>(`api/ach-board/posts/${postId}/read`, null)
      .pipe(map((data: ACHInformationDto) => data));
  }

  async GetBoardPostByIdAsync(postId: number) {
    return lastValueFrom(
      this.http
        .get<ViewBoardPostDto>(`api/ach-board/posts/${postId}`)
        .pipe(map((data: ViewBoardPostDto) => data)),
    );
  }

  async DeleteBoardPostAsync(postId: string) {
    return lastValueFrom(
      this.http.delete<void>(`api/ach-board/posts/${postId}`),
    );
  }
}
